import React from 'react';
import './Footer.css';

import GooglePlay from '../../assets/play.png';
import AppleApp from '../../assets/apple.png';

import ComplimentsIcon from '../../assets/icon 1.png';
import ComplaintsIcon from '../../assets/icon 3.png';
import ConsultationIcon from '../../assets/icon 2.png';
import AskQueryIcon from '../../assets/icon 4.png';

import { Link } from 'react-router-dom';

const Footer = (props) => {
	// const quickLinks = new Array(8).fill({ title: 'Lorem Ipsum dolor' });
	const askHelp = [
		{ title: 'Testimonials', image: ComplimentsIcon },
		{ title: 'Call us', image: ConsultationIcon },
		{ title: 'Request a quote', image: ComplaintsIcon },
		{ title: 'Ask Query', image: AskQueryIcon },
	];
	return (
		<div className='Footer'>
			<div className='Footer-above'>
				<div className='seek-help'>
					<div className='grey-part'></div>
					<div className="container-width">
						<div className='white-part row'>
							{askHelp.map((aHelp) => (
								<div className='col m3 s6'>
									<div className='outer'>
										<div className='inner'>
											<img src={aHelp.image} alt={`${aHelp.title} icon`} />
										</div>
									</div>
									<h5>{aHelp.title}</h5>
								</div>
							))}
						</div>
					</div>
				</div>
			</div>
			<div className='Footer-below'>
				<div className="container-width">
					<div className='about'>


						<div className='row quick-links'>
							<div className='col m3 s6'>
								<h6>About Detoxa</h6>
								<hr className='first-hr' />
								<p>Corporate Partnership</p><p>NGO Partnership</p>
								

							</div>
							<div className='col m3 s6'>
								<h6>Important Links</h6>
								<hr className='first-hr' />
								<p>School Partnership</p><p>Doctors Connect</p>
											</div>

							<div className='col m3 s6'>
								<h6>About Detoxa</h6>
								<hr className='first-hr' />
								<p>Gold Membership</p><p>Detoxa - US</p>
							

							</div>
							<div className='col m3 s6'>
								<h6>Important Links</h6>
								<hr className='first-hr' />
								<p>Silver Membership</p>
								<p>Contact Us</p>
							</div>




						</div>
						<hr className='second-hr' />
					</div>
				</div>
				<div className="social-links-bg">
					<div className="container-width">
						<div className='row marg-bott0' >
							<div className='follow-us col s6'>
								<h6>Follow Us</h6>
								<div className='row social-links marg-bott0'>
									<Link>
										<i class='fab fa-facebook-f'></i>
									</Link>
									<Link>
										<i class='fab fa-twitter'></i>
									</Link>
									<Link>
										<i class='fab fa-linkedin-in'></i>
									</Link>
									<Link>
										<i class='fab fa-youtube'></i>
									</Link>
									<Link>
										<i class='fab fa-instagram'></i>
									</Link>
									<Link>
										<i class='fab fa-pinterest-p'></i>
									</Link>
								</div>
							</div>
							<div className='download col s6'>
								<h6>
									Download <span>detoxa</span> App
						</h6>
								<div className='row marg-bott0'>
									<Link>
										<img
											className='col s6'
											src={GooglePlay}
											alt='Google Play Store come here'
										/>
									</Link>
									<Link>
										<img
											className='col s6'
											src={AppleApp}
											alt='Apple App Store come here'
										/>
									</Link>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default Footer;
